<div class="title-bar">
  <a class="expand-icon" data-bs-toggle="collapse" data-bs-parent="#accordion" [href]="'#'+section" (click)="toggleIcon()"><i [class]="iconStyle"></i></a>
  <h2>{{title}}</h2>
</div>
